/* eslint-disable react/jsx-no-bind */

import * as account from "../../lib/api/account"
import * as guests from "../../lib/api/guests";
import AlertModal from "../AlertModal";
import dateFns from "date-fns";
import DeleteConfirmModal from "../DeleteConfirmModal";
import Loader from "../Loader";
import logger from "../../lib/logger";
import React, { PureComponent } from "react";
import {
    Button,
    Grid,
    Row,
    Col,
    Form,
    FormGroup,
    FormControl,
    ControlLabel,
    Table,
} from "react-bootstrap";
import { css, StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
    center: {
        textAlign: "center",
    },
    searchButton: {
        marginTop: 24
    },
    linkButton: {
        padding: 0,
        marginTop: "2px",
        marginBottom: "10px",
    },
    linkButtonText: {
        margin: 0,
    },
});

const strings = {
    title: "Account Deletion | Habit CMS",
    search: "Search",
    name: "Name",
    email: "Email",
    phone: "Phone #",
    phoneVerified: "Phone Verified",
    registrationDate: "Registration Date",
    delete: "Delete",
    accountDeletion: "Account Deletion",
    enterText: "Email or Phone",
    noMatches: "No matches were found.",
    confirmDelete: "Are you sure you want to delete this account?",
    searchError: "There was an error when searching for guests. Please try again.",
    deleteError: "There was an error when trying to delete this guest. No changes were made."
};

export default class AccountDeletionPage extends PureComponent {
    state = {
        search: "",
        loading: false,
        guests: [],
        selectedGuest: null,
        showDeleteConfirmModal: false,
        message: "",
        showAlertModal: false,
        alertMsg: "",
    };

    componentDidMount() {
        this._isMounted = true;
        document.title = strings.title;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _onSearchChange = e => {
        this.setState({ search: e.target.value });
    };

    _search = () => {
        this.setState({ loading: true });
        guests
            .getGuestsExactMatch(this.state.search)
            .then(resp => {
                this.setState({
                    loading: false,
                    guests: resp.guests,
                    message: resp.guests.length !== 0 ? "" : strings.noMatches
                });
            })
            .catch(err => {
                logger.warn(err);
                this.setState({ loading: false, showAlertModal: true, alertMsg: strings.searchError });
            });
    };

    _formatRegistrationDate = dateString => {
        const date = new Date(dateString);
        return dateFns.format(date, "MM-DD-YYYY hh:mma");
    };

    _handleSearch = (e) => {
        e.preventDefault();
        this._search();
    }

    _onDeleteClick = g => {
        this.setState({ selectedGuest: g, showDeleteConfirmModal: true })
    }

    _closeDeleteConfirmModal = () => {
        this.setState({ selectedGuest: null, showDeleteConfirmModal: false })
    }

    _deleteGuest = () => {
        this.setState({ loading: true });
        account
            .ccpaDelete(this.state.selectedGuest.email)
            .then(() => {
                this.setState({
                    loading: false,
                    guests: this.state.guests.filter(g => g.email !== this.state.selectedGuest.email),
                    selectedGuest: null,
                    message: "",
                    showDeleteConfirmModal: false
                });
            })
            .catch(err => {
                logger.warn(err);
                this.setState({ loading: false, showAlertModal: true, alertMsg: strings.deleteError });
            });
        return
    }

    _hideAlertModal = () => {
        this.setState({ showAlertModal: false });
    };

    render() {
        return (
            <Grid>
                <Row>
                    <h3>{strings.accountDeletion}</h3>
                </Row>
                <Row>
                    <Form onSubmit={this._handleSearch}>
                        <Col md={4}>
                            <FormGroup controlId="search">
                                <ControlLabel>{strings.search}</ControlLabel>
                                <FormControl
                                    id="search"
                                    type="text"
                                    value={this.state.search}
                                    placeholder={strings.enterText}
                                    onChange={this._onSearchChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <Button
                                type="submit"
                                bsStyle="primary"
                                className={css(styles.searchButton)}
                                disabled={this.state.loading}
                            >
                                {strings.search}
                            </Button>
                        </Col>
                    </Form>
                </Row>
                {this.state.guests.length !== 0 ? (
                    <Row>
                        <Col md={12}>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>{strings.name}</th>
                                        <th>{strings.email}</th>
                                        <th>{strings.phone}</th>
                                        <th>{strings.registrationDate}</th>
                                        <th>{strings.phoneVerified}</th>
                                        <th>{strings.delete}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.guests.map((g, i) => 
                                        <tr key={i}>
                                            <td>{`${g.firstName} ${g.lastName}`}</td>
                                            <td>{g.email}</td>
                                            <td>{g.phoneNumber}</td>
                                            <td>{this._formatRegistrationDate(g.createDate)}</td>
                                            <td>{g.isPhoneNumberVerified ? "Yes" : "No"}</td>
                                            <td>
                                                <Button
                                                    className={css(styles.linkButton)}
                                                    bsStyle="link"
                                                    onClick={() => this._onDeleteClick(g)}
                                                    disabled={this.state.loading}
                                                >
                                                    <p className={css(styles.linkButtonText)}>{strings.delete}</p>
                                                </Button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                            {this.state.loading ? <Loader /> : null}
                        </Col>
                    </Row>
                ) : (
                    <h4>
                        {this.state.message}
                    </h4>
                )}
                <DeleteConfirmModal
                    show={this.state.showDeleteConfirmModal}
                    title={strings.confirmDelete}
                    handleClose={this._closeDeleteConfirmModal}
                    handleConfirm={this._deleteGuest}
                />
                <AlertModal
                    show={this.state.showAlertModal}
                    alertMessage={this.state.alertMsg}
                    handleClose={this._hideAlertModal}
                />
            </Grid>
        );
    }
}
